import React, { Component } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { Fetcher } from '../../../../Helpers/fetcher.js';
import { Notify } from '../../../../Helpers/notification.js';
import './AddDocument.css';

const DOCUMENT_TYPES = [
	{ value: 'SIMPLE_DOCUMENT', label: 'Simple Document' },
	{ value: 'TEMPLATE_1', label: 'TEMPLATE 1' },
	{ value: 'TEMPLATE_2', label: 'TEMPLATE 2' },
	{ value: 'TEMPLATE_3', label: 'TEMPLATE 3' },
	{ value: 'TEMPLATE_4', label: 'TEMPLATE 4' },
	{ value: 'TEMPLATE_5', label: 'TEMPLATE 5' },
	{ value: 'TEMPLATE_6', label: 'TEMPLATE 6' },
	{ value: 'TEMPLATE_7', label: 'TEMPLATE 7' },
	{ value: 'TEMPLATE_8', label: 'TEMPLATE 8' },
	{ value: 'TEMPLATE_9', label: 'TEMPLATE 9' }
];

const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt'];
const MAX_FILE_SIZE = 100 * 1024 * 1024;

class AddDocument extends Component {
	constructor(props) {
		super(props);
		this.fileInput = React.createRef();
		this.state = {
			documentName: '',
			documentType: 'SIMPLE_DOCUMENT',
			selectedFile: null,
			dragActive: false,
			submitting: false
		};
	}

	componentDidMount() {
		if (this.props.app.role !== 'ROLE_SADMIN' && this.props.app.role !== 'ROLE_SUB_SADMIN') {
			this.props.history.replace('/');
		}
	}

	setvalue = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	getExtension = (fileName) => {
		const idx = fileName.lastIndexOf('.');
		return idx === -1 ? '' : fileName.substring(idx + 1).toLowerCase();
	};

	validateAndSetFile = (file) => {
		if (!file) return;
		const ext = this.getExtension(file.name);
		if (!ALLOWED_EXTENSIONS.includes(ext)) {
			Notify.notify('Only PDF, Word, Excel, CSV or TXT files are allowed');
			return;
		}
		if (file.size > MAX_FILE_SIZE) {
			Notify.notify('File size must not exceed 100 MB');
			return;
		}
		this.setState({ selectedFile: file });
	};

	onFileChange = (e) => {
		this.validateAndSetFile(e.target.files[0]);
	};

	onDrop = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ dragActive: false });
		if (e.dataTransfer.files && e.dataTransfer.files[0]) {
			this.validateAndSetFile(e.dataTransfer.files[0]);
		}
	};

	onDragOver = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ dragActive: true });
	};

	onDragLeave = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ dragActive: false });
	};

	formatFileSize = (bytes) => {
		if (bytes < 1024) return bytes + ' B';
		if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
		return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
	};

	handleSubmit = (e) => {
		e.preventDefault();
		if (!this.state.documentName || this.state.documentName.trim() === '') {
			Notify.notify('Please enter a document name');
			return;
		}
		if (!this.state.selectedFile) {
			Notify.notify('Please select or drop a file to upload');
			return;
		}

		const fd = new FormData();
		fd.append('userId', this.props.app.userId);
		fd.append('documentName', this.state.documentName);
		fd.append('documentType', this.state.documentType);
		fd.append('documentFile', this.state.selectedFile);

		this.setState({ submitting: true });
		Fetcher.post(this.props.app.apiPath + '/api/obd/document/upload', { method: 'POST', body: fd })
			.then(res => {
				Notify.notify(res.message);
				if (res.message && res.message.toLowerCase().includes('success')) {
					const urlPrefix = this.props.app.urlPrefix || '';
					this.props.history.push(`${urlPrefix}/superadmin-api-docs/upload-document`);
				}
			})
			.catch(err => {
				console.log('Error in uploading Document', err);
				Notify.notify('Error in uploading Document');
			})
			.finally(() => this.setState({ submitting: false }));
	};

	render() {
		const { documentName, documentType, selectedFile, dragActive, submitting } = this.state;

		return (
			<Card>
				<Card.Header>Upload Document</Card.Header>
				<Card.Body>
					<Form onSubmit={this.handleSubmit}>
						<Row className="mb-3">
							<Col sm={4}>
								<Form.Group>
									<Form.Label>Document Name</Form.Label>
									<Form.Control name="documentName" type="text" value={documentName} onChange={this.setvalue} required />
								</Form.Group>
							</Col>
							<Col sm={4}>
								<Form.Group>
									<Form.Label>Document Type</Form.Label>
									<Form.Control as="select" name="documentType" value={documentType} onChange={this.setvalue}>
										{DOCUMENT_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
									</Form.Control>
								</Form.Group>
							</Col>
						</Row>

						<Form.Group>
							<Form.Label>File</Form.Label>
							<div
								className={`document-dropzone${dragActive ? ' document-dropzone-active' : ''}`}
								onDrop={this.onDrop}
								onDragOver={this.onDragOver}
								onDragLeave={this.onDragLeave}
								onClick={() => this.fileInput.current.click()}
							>
								<i className="fa fa-cloud-upload fa-2x mb-2 d-block"></i>
								{selectedFile ? (
									<span>{selectedFile.name} ({this.formatFileSize(selectedFile.size)})</span>
								) : (
									<span>Drag and drop a file here, or click to browse</span>
								)}
								<div className="document-dropzone-hint">PDF, Word, Excel, CSV or TXT &mdash; max 100 MB</div>
							</div>
							<Form.Control
								ref={this.fileInput}
								type="file"
								onChange={this.onFileChange}
								accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
								className="d-none"
							/>
						</Form.Group>

						<Button variant="primary" type="submit" disabled={submitting}>
							{submitting ? 'Uploading...' : 'Upload'}
						</Button>
					</Form>
				</Card.Body>
			</Card>
		);
	}
}

export default AddDocument;
